<!--
//================================================================================
// ID:BC016
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC016
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/09/09 | 富士通株式会社         | 新規作成
// 01.01.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<error-message />
		<h2 class="contents__h2">利用者情報</h2>
		<section>
			<table class="contents__table--stripe detail" >
				<tbody>
					<tr class="contents__input--tr">
						<th  class="contents__input--title th-border th-paddingtop" >
							氏名
						</th>		    
						<td class="td-border contents__input--label">
							{{ disp.nmName }}
						</td>
					</tr>
					<tr style="background-color: #fdfdfd">
						<th  class="contents__input--titlekana" >
							フリガナ							
						</th>				    
						<td class="contents__input--label contents__input--labelkana">
							{{ disp.nmKana1 }}&nbsp;{{ disp.nmKana2 }}
						</td>
					</tr>

					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title th-border th-paddingtop">
							日本での通称名
						</th>
						<td class="td-border contents__input--label">
							{{ disp.nmTusyoname }}
						</td>
					</tr>
					<tr class="background__color--light-gray">
						<th  class="contents__input--titlekana">
							フリガナ
						</th>
						<td class="contents__input--label contents__input--labelkana">
							{{ disp.nmTusyokana1 }}&nbsp;{{ disp.nmTusyokana2 }}
						</td>
					</tr>

					<tr class="contents__input--tr">
						<th class="contents__input--title th-paddingtop">
							生年月日
						</th>
						<td class="contents__input--label">
							{{ co_editDateSlash(disp.dtBirthday) }}
						</td>
					</tr>

					<tr class="background__color--light-gray">
						<th class="contents__input--title th-paddingtop">
							郵便番号
						</th>
						<td class="contents__input--label">
							{{ disp.idZip }}
						</td>
					</tr>

					<tr class="contents__input--tr">
						<th  class="contents__input--title th-paddingtop" >
							現住所
						</th>				    
						<td class="contents__input--label">
							<div>{{ disp.txNowadr1 }}</div>
							<div>{{ disp.txNowadr2 }}</div>
							<div>{{ disp.txNowadr3 }}</div>
						</td>
					</tr>

					<tr class="background__color--light-gray">
						<th  class="contents__input--title th-paddingtop">
							電話番号
						</th>
						<td class="contents__input--label">
							{{ disp.idTel }}
						</td>
					</tr>

					<tr class="contents__input--tr">
						<th  class="contents__input--title th-paddingtop">
							メールアドレス
						</th>
						<td class="contents__input--label contents__kaigyo--css">
							{{ disp.idMailaddress }}
						</td>
					</tr>

					<tr class="background__color--light-gray">
						<th  class="contents__input--title th-paddingtop">
							ロック状況
						</th>
						<td class="contents__input--label font__enabled">
							{{ disp.enabled }}
						</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<div class="contents__div--center" >
				<input type="button" value="戻る" ref="goBackBtn" tabindex="1" class="contents__btn--cancel" @click="reSearch"/>
			</div>
			<br/>
		</section>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_editDateSlash } from '@/common/stringUtility.js';
import { co_toTrans, co_clearParam } from '@/common/screenUtility.js';

import { HTTP_STATUS } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS, STORE_VIEW_GET_PARAMS } from '@/const/store.js';
import { PATH_BC016_INIT } from '@/const/route.js';

export default {
	name: "BC016",
	components: {
		'error-message': ErrorMessage,
	},
	data: function () {
		return {
			form: {
			},
			disp: {
				nmName: '',				// 氏名
				nmKana1: '',			// フリガナ（氏）
				nmKana2: '',			// フリガナ（名）
				nmTusyoname: '',		// 通称名
				nmTusyokana1: '',		// 通称フリガナ（氏）
				nmTusyokana2: '',		// 通称フリガナ（名）
				dtBirthday: '',			// 生年月日
				idZip: '',				// 郵便番号
				txNowadr1: '',			// 現住所１
				txNowadr2: '',			// 現住所２
				txNowadr3: '',			// 現住所３
				idTel: '',				// 電話番号
				idMailaddress: '',		// メールアドレス
				enabled: '',			// ロック状況
			},
			enabled: '',				// ロック状況
			idRiyosya: '',				// 利用者ID
			co_editDateSlash: co_editDateSlash,
		};
	},
	mounted: async function () {
		await this.$nextTick();

		// フォーカス設定
		this.$refs.goBackBtn.focus();
	},
	// 初期表示
	created: async function() {

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// 前画面からのパラメータを設定
		let param = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC016');
		this.enabled = param.enabled;
		this.idRiyosya = param.idRiyosya;

		// 画面間パラメータを削除
		co_clearParam('BC016');

		// 利用者情報を取得
		let self = this;
		let riyosyaInfo = {
			'idRiyosya' : this.idRiyosya
		};
		let data = await co_post(PATH_BC016_INIT, riyosyaInfo, function(res, handle){

			if (res.status == HTTP_STATUS.OK) {
				return handle(res);
			} else {
				// ローディング表示終了
				self.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		});

		this.disp.nmName = data.nmName1 + "　" + data.nmName2;
		this.disp.nmKana1 = data.nmKana1;
		this.disp.nmKana2 = data.nmKana2;
		this.disp.nmTusyoname = data.nmTusyoname1 + "　" + data.nmTusyoname2;
		this.disp.nmTusyokana1 = data.nmTusyokana1;
		this.disp.nmTusyokana2 = data.nmTusyokana2;
		this.disp.dtBirthday = data.dtBirthday;
		this.disp.idZip = data.idZip;
		this.disp.txNowadr1 = data.txNowadr1;
		this.disp.txNowadr2 = data.txNowadr2;
		this.disp.txNowadr3 = data.txNowadr3;
		this.disp.idTel = data.idTel;
		this.disp.idMailaddress = data.idMailaddress;
		if (this.enabled == "ﾛｯｸｱｳﾄ"){
			this.disp.enabled = "ロックアウト";
		}

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	methods: {
		reSearch: function () {
			// 利用者情報検索・一覧画面に遷移
			co_toTrans('BC015');
		}
	}
}
</script>

<style scoped>
.th-paddingtop {
	padding-top: 10px;
}
.th-border {
	border-bottom: none;
}
.td-border {
	border-bottom: none;
}
.font__enabled {
	color: red;
	font-weight: bold;
}
.contents__input--titlekana {
	padding-top: 5px !important;
	text-align: left;
}
.contents__input--labelkana {
	padding-top: 5px !important;
}
</style>
